export const CREATING_GOAL = 'creatingGoal'
export const CREATING_GOALS = 'creatingGoals'
export const GOAL_CREATED = 'goalCreated'
export const GOALS_CREATED = 'goalsCreated'
export const GOAL_RECEIVED = 'goalReceived'
export const GOALS_RECEIVED = 'goalsReceived'
export const EDITING_GOALS = 'editingGoals'
export const LOADING_GOALS = 'loadingGoals'

export const createGoal = goal => ({
  type: CREATING_GOAL,
  payload: goal
})

export const createGoals = goals => ({
  type: CREATING_GOALS,
  payload: goals
})

export const receiveGoals = goals => ({
  type: GOALS_RECEIVED,
  payload: goals
})

export const receiveGoal = goal => ({
  type: GOAL_RECEIVED,
  payload: goal
})

export const editGoals = values => ({
  type: EDITING_GOALS,
  payload: values
})

export const loadGoals = patientId => ({
  type: LOADING_GOALS,
  payload: patientId
})



// WEBPACK FOOTER //
// ./src/Goal/actions.js